"use strict";

Shopify.theme.jsFeaturedCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if (this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if (this.collection_style == 'slider') {
      this.createSlider();
    }
  },
  createSlider: function createSlider() {
    var featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');
    var cellAlign = featuredCollectionSlider.data('cell-align');
    var wrapAround = featuredCollectionSlider.data('wrap-around');
    var slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: typeof cellAlign === 'undefined' ? 'center' : cellAlign,
      wrapAround: typeof wrapAround === 'undefined' ? true : wrapAround
    };
    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: slideData.cellAlign,
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function ready() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on('settle.flickity', function () {
            $(featuredCollectionSlider).flickity('resize');
          });

          // Third-party widgets (eg. the Growave review-stars placeholder) render
          // empty and fill in asynchronously after Flickity has already measured
          // cell height, so the extra height gets clipped by .flickity-viewport's
          // overflow:hidden. Watch each cell and resize whenever its height changes.
          if (typeof ResizeObserver !== 'undefined') {
            featuredCollectionSlider.each(function () {
              var $slider = $(this);
              var resizeObserver = new ResizeObserver(function () {
                $slider.flickity('resize');
              });
              $slider.find('.gallery-cell').each(function () {
                resizeObserver.observe(this);
              });
            });
          }
        }
      }
    });
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};